'use strict';

wbApp.controller('PicturesCtrl', ['$scope', '$modal', 'picturesSvc', 'localStorageService', 'messageBoxSvc',
function ($scope, $modal, picturesSvc, localStorageService, messageBoxSvc) {

    localStorageService.bind($scope, 'size', 'medium', 'picture-gallery-picture-size');

    $scope.setSelected = function (picture) {
        $scope.selected = picture;
    }

    $scope.pictures = picturesSvc.getAllAsync();

    $scope.onDeleteBtnClick = function (picture) {
        messageBoxSvc.showMessageDlg({
            title: 'TXT_TITLE_CONFIRM_DELETE',
            message: picture.isUsed ? 'TXT_TEXT_CONFIRM_DELETE_PICURE_IN_USE' : 'TXT_TEXT_CONFIRM_DELETE_PICURE',
            buttons: [{
                text: 'TXT_BTN_NO'
            }, {
                text: 'TXT_BTN_YES',
                callback: function () { picturesSvc.remove(picture); }
            }]
        });
    }

    var detailDialogPromise = $modal({
        templateUrl: 'storage/pictures/pictures-detail.html',
        show: false,
        scope: $scope
    });

    $scope.onUploadImageClick = function () {
        detailDialogPromise.$promise.then(function () {
            detailDialogPromise.show();
        });
    }

}]);
